import { ReactNode, Children } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'

import { BrandIcon, BrandLogo } from '@authy/lib-client/assets'

import { adminAppState } from '@/appState'
import { Divider } from '@/App/Navigation/Sidebar/Divider'

import { TenantMenu } from './TenantMenu'

type HeaderProps = {
    collapsed: boolean
    onActivate: () => void
    children?: ReactNode
}

export const Header = observer(({ collapsed, onActivate, children }: HeaderProps) => {
    const { tenant, application } = adminAppState

    let content: ReactNode

    if (tenant && application) {
        content = <TenantMenu collapsed={collapsed} onActivate={onActivate} />
    } else {
        content = (
            <div className={classNames('pt-2', { 'px-2': !collapsed, 'flex justify-center': collapsed })}>
                {collapsed ? <BrandIcon className="size-8" /> : <BrandLogo className="h-8" />}
            </div>
        )
    }

    return (
        <>
            <div
                className={classNames({
                    'px-3': !collapsed,
                    'pl-1 pr-2': collapsed,
                })}
            >
                <div className={classNames('shrink-0 grow-0 pt-4 md:pt-2')}>
                    <div>{content}</div>
                    {Children.count(children) > 0 && <div className="mt-3">{children}</div>}
                </div>
            </div>
            <Divider />
        </>
    )
})
